import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { WalletIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';
import CurrencyIcon from './CurrencyIcons';

const SidebarWallet = () => {
  const { user, refreshWalletBalance } = useAuth();
  const [loading, setLoading] = useState(false);
  
  // Get wallet balances from user object
  const balances = {
    BAI: user?.baiBalance || '0',
    BNB: user?.bnbBalance || '0',
    IMX: user?.imxBalance || '0',
    USDT: user?.usdtBalance || '0'
  };
  
  // Refresh balances
  const handleRefresh = async () => {
    if (loading) return;
    
    setLoading(true);
    try {
      await refreshWalletBalance();
    } catch (error) {
      console.error('Error refreshing wallet:', error);
    } finally {
      setLoading(false);
    }
  };
  
  // Auto-refresh balances when component mounts
  useEffect(() => {
    if (user?.address) {
      handleRefresh();
    }
  }, [user?.address]);
  
  if (!user?.address) {
    return null;
  }
  
  return (
    <div className="relative">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center text-gray-300">
          <WalletIcon className="h-4 w-4 mr-1 text-violet-400" />
          <span className="text-sm font-medium">Wallet</span>
        </div>
        <button 
          onClick={handleRefresh}
          className="text-gray-400 hover:text-white transition-colors"
          disabled={loading}
        >
          <ArrowPathIcon className={`h-3 w-3 ${loading ? 'animate-spin text-violet-400' : ''}`} />
        </button>
      </div>
      
      <div className="space-y-2">
        {Object.entries(balances).map(([currency, balance]) => (
          <div key={currency} className="flex justify-between items-center">
            <div className="flex items-center">
              <CurrencyIcon currency={currency} size="sm" className="mr-1.5" />
              <span className="text-xs text-gray-400">{currency}</span>
            </div>
            <span className="text-xs font-medium text-white">{balance}</span>
          </div>
        ))}
      </div>
      
      <Link 
        to="/wallet" 
        className="block mt-3 text-center text-xs text-violet-400 hover:text-violet-300 transition-colors"
      >
        View Wallet
      </Link>
    </div>
  );
};

export default SidebarWallet;
